<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CommonEmpty',
})
</script>
<template>
  <Empty image="/img/default/pic-default-empty.svg" :imageStyle="{ height: '130px' }" v-bind="$attrs">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}" />
    </template>
  </Empty>
</template>

<script lang="ts" setup name="CommonEmpty">
import { Empty } from 'ant-design-vue'
</script>
